import type { ReactNode } from "react";
import { Icon, type IconComponent } from "./icons";

export type CalloutTone = "rule" | "accent" | "strike" | "ok";

export interface CalloutProps {
  tone?: CalloutTone;
  title?: ReactNode;
  children: ReactNode;
  icon?: IconComponent;
}

const TONE_CLASS: Record<CalloutTone, string> = {
  rule: "border-l-[var(--primary)]",
  accent: "border-l-[var(--accent)]",
  strike: "border-l-[var(--strike)]",
  ok: "border-l-[var(--ok)]",
};

export function Callout({ tone = "rule", title, children, icon: I = Icon.Info }: CalloutProps) {
  return (
    <div className={`pl-5 border-l-2 py-1.5 ${TONE_CLASS[tone]}`}>
      {title && (
        <div className="flex items-center gap-2 mb-1">
          <I size={13} strokeWidth={2} className="text-[var(--ink)]" />
          <div className="label text-[var(--ink)]">{title}</div>
        </div>
      )}
      <div className="body text-[13.5px]">{children}</div>
    </div>
  );
}
